import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconArrowSpinLeft12 from './IconArrowSpinLeft12';
import IconArrowSpinLeft16 from './IconArrowSpinLeft16';
import IconArrowSpinLeft20 from './IconArrowSpinLeft20';
import IconArrowSpinLeft24 from './IconArrowSpinLeft24';
import IconArrowSpinLeft32 from './IconArrowSpinLeft32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconArrowSpinLeft = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconArrowSpinLeft12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconArrowSpinLeft16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconArrowSpinLeft20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconArrowSpinLeft24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconArrowSpinLeft32 {...props} />}
        </span>
    );
};
IconArrowSpinLeft.displayName = 'FondueIconArrowSpinLeft';

export default memo(IconArrowSpinLeft);
